import React from 'react';
import styled from 'styled-components';
import Link from '../../common/Link';
import { useState } from 'react';

import RegistrationForm from './RegistrationForm';
import Countdown from '../../common/Countdown';
import { linkToTelegramChat } from '../../../utils';
import { useTranslation, Trans } from 'react-i18next';
// import SignUpCalendar from '../../calendar/SignUpCalendar.js';

const Main = styled.main`
  background-color: ${(p) => p.theme.color.containerBg};
  padding: 1rem;

  p {
    max-width: 800px;
  }
`;
export const signupOpens = new Date('2026-02-17T12:00:00+02:00'); // initial signup
export const signupCloses = new Date('2026-03-09T23:59:59+02:00');
export const postSignupOpens = new Date('2026-03-31T12:00:00+02:00'); // signup for remaining spots
export const postSignupCloses = new Date('2026-04-29T00:00:00+02:00'); // 48h before the end of the season

const Registration = () => {
  const { t } = useTranslation();
  const [showCountdown] = useState(new Date() < signupOpens);

  if (new Date() >= postSignupCloses) {
    return (
      <Main>
        <h2>{t('signup.closed.title')}</h2>
        <p>
          <Trans
            i18nKey="signup.closed.remaining"
            components={[<a href="mailto:toimitus@radiodiodi.fi"> </a>]}
          />
        </p>
      </Main>
    );
  }

  return (
    <>
      {showCountdown && (
        <div style={{ paddingTop: '5rem', paddingBottom: '5rem' }}>
          <Countdown title={t('signup.countdown.title')} to={signupOpens} />
        </div>
      )}
      <Main>
        {/* {new Date() >= postSignupOpens ? (
        <h2>{t('signup.postregistration.open')}</h2>
      ) : new Date() >= signupCloses ? (
        <h2>{t('signup.postregistration.soon')}</h2>
      ) : new Date() >= signupOpens ? (
        <h2>{t('signup.signup.title')}</h2>
      ) : (
        <h2>{t('signup.preRegistration.pageTitle')}</h2>
      )} */}

        {/* {new Date() >= postSignupOpens && (
        <h4>
          <i>{t('signup.notice')}</i>
        </h4>
      )} */}
        <h2>{t('signup.title')}</h2>

        <p>{t('signup.paragraph1')}</p>
        <p>
          <Trans
            i18nKey="signup.paragraph2"
            components={[
              <a
                title="Telegram-tiedotus"
                href={linkToTelegramChat('radiodiodi')}
                target="_blank"
                rel="noopener noreferrer"
              >
                {' '}
              </a>,
              // <a
              //   title="Telegram-keskustelu"
              //   href={linkToTelegramChat('radiodiodichat')}
              //   target="_blank"
              //   rel="noopener noreferrer"
              // >
              //   {' '}
              // </a>,
            ]}
          />
        </p>
        <p>
          <Trans
            i18nKey="signup.paragraph3"
            components={[
              <Link to="/guide/checklist" />,
              <Link to="/guide/faq" />,
              <Link to="/library" />,
            ]}
          />
        </p>
        <p>
          {t('signup.paragraph4')}{' '}
          <a href="mailto:toimitus@radiodiodi.fi">toimitus@radiodiodi.fi</a>
        </p>
        <p>{t('signup.paragraph5')}</p>
        {/* <SignUpCalendar /> */} {/* TODO: uncomment after slots have been reserved */}

        <RegistrationForm
          signupOpens={
            new Date() < signupCloses ? signupOpens : postSignupOpens
          }
          signupCloses={
            new Date() < signupCloses ? signupCloses : postSignupCloses
          }
          isPostSignup={new Date() >= postSignupOpens}
        />
      </Main>
    </>
  );
};

export default Registration;
